import React from 'react';
import Button from '../CommonComponents/Button';

const HotelCard = ({ 
  hotel, 
  reverse = false 
}) => {
  const {
    name,
    image,
    location,
    overview,
    rooms,
    dining,
    facilities,
    service,
    experience
  } = hotel;

  return (
    <section className="section list-wrapper">
      <div className="container">
        <div className={`row ${reverse ? 'row-reverse' : ''} align-items-center`}>
          <div className="col-md-6">
            <div className="img-wrap">
              <img src={image} className="img-fluid raduis-1r" alt={`${name}, a luxury hotel in ${location}`} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="hotel-desc">
              <h3>{name}</h3>
              <div id="wlcom-desc1">
                <p><strong>Location:</strong> {location}</p>
                <p><strong>Overview:</strong> {overview}</p>
                <p><strong>Rooms and Amenities:</strong> {rooms}</p>
                <p><strong>Dining:</strong> {dining}</p>
                <p><strong>Facilities:</strong> {facilities}</p>
                <p><strong>Service:</strong> {service}</p>
                <p><strong>Overall Experience:</strong> {experience}</p>
              </div>
              <div className="button-wrap">
                <Button to="/contact-us" text="Reserve Now" aria-label={`Reserve a stay at ${name}`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HotelCard;